import { GridColDef } from "@mui/x-data-grid";
import { formatDate } from "../../../helpers/formatingFunctions";
import UnassignButton from "../../../components/Fleet/UnassignButton/UnassignButton";

export const assignedDispatchersTableColumns: GridColDef[] = [
  { field: "firstName", headerName: "First Name", width: 150 },
  { field: "lastName", headerName: "Last Name", width: 150 },
  { field: "email", headerName: "Email", width: 200 },
  {
    field: "dateAssigned",
    headerName: "Date Assigned",
    width: 150,
    valueFormatter: (params: any) => {
      return params ? formatDate(params) : "";
    },
  },
  {
    field: "dateUnassigned",
    headerName: "Date Unassigned",
    width: 150,
    valueFormatter: (params: any) => {
      return params ? formatDate(params) : "";
    },
  },
  {
    field: "unassignDispatcher",
    headerName: "",
    width: 200,
    renderCell: (params) => {
      return params.row.dateUnassigned ? null : (
        <UnassignButton id={params.row.driverId} type="dispatcher" />
      );
    },
  },
];
